import script from "./DeveloperWhiteListVendor.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperWhiteListVendor.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperWhiteListVendor.vue?vue&type=style&index=0&id=56a2e688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a2e688"]])

export default __exports__